// extracted by mini-css-extract-plugin
export default {"banner-wrapper":"Banner_banner-wrapper__tkCt1"};